import React from 'react'
import './Upcoming.css'

/** Public folder; must not be referenced in CSS url() or webpack tries to resolve it as a module. */
const SIGNATURE_BG = `${(process.env.PUBLIC_URL ?? '').replace(/\/$/, '')}/img/events/juneteenth/steampunkbackground.png`

const Upcoming: React.FC = () => {

    const events: any = [
        {
            title: `Juneteenth Freedom Lab & Family Day`,
            location: 'Church Art House, 3101 S 20th St, Omaha, NE 68107',
            date: 'Saturday, June 13th, 2026 | 12pm-3pm',
            eventDate: '2026-06-13',
            image: './img/events/juneteenth/JuneteenthFreedomLab.png',
            link: '/juneteenth',
            description: `An interactive, hands-on space where community and families explore the meaning of freedom through creativity, history, science, and imagination.`,
        },
        {
            title: `Juneteenth Steampunk Vaudeville Show`,
            location: 'Church Art House, 3101 S 20th St, Omaha, NE 68107',
            date: 'Saturday, June 13th, 2026 | 7pm',
            eventDate: '2026-06-13',
            image: './img/events/juneteenth/JuneteenthVaudevilleShow.png',
            link: '/juneteenth',
            description: `Magic ~ Burlesque ~ Vendors ~ and More!  (21+ Only)`,
        },
        {
            title: `Juneteenth Steampunk Ball`,
            location: 'Church Art House, 3101 S 20th St, Omaha, NE 68107',
            date: 'Sunday, June 14th, 2026 | VIP Dinner 6-8pm | The Grand Ball 8-11pm',
            eventDate: '2026-06-14',
            image: './img/events/juneteenth/Ball.png',
            link: '/juneteenth',
            description: ``,
        },
        // {
        //     title: `The House Book Club: March`,
        //     location: 'Zoom',
        //     date: 'Thursday, March 5th, 2026 | 7:00pm CST',
        //     eventDate: '2026-03-05',
        //     image: './img/events/2026/housebookclubmarch.jpg',
        //     link: 'https://www.eventbrite.com/e/the-house-book-club-march-tickets-1979106545955?aff=ebdsoporgprofile',
        //     description: `Join us for our monthly book club discussion! This month we're reading "The Secret Lives of Church Ladies" by Deesha Philyaw. Connect with fellow book lovers in a welcoming virtual space.`,
        // },
        // {
        //     title: `Game Night with the Luminarium`,
        //     location: 'Kiewit Luminarium, Omaha, Nebraska',
        //     date: 'Friday, March 20th, 2026 | 7:00pm',
        //     eventDate: '2026-03-20',
        //     image: './img/events/2026/gamenightluminarium.jpg',
        //     link: 'https://www.eventbrite.com/e/game-night-with-the-luminarium-tickets-1143534966869?aff=ebdsoporgprofile',
        //     description: `Experience game night at the amazing Luminarium! Explore their incredible space while enjoying board games, tabletop games, and great company.`,
        // },
        // {
        //     title: `The House Book Club: April`,
        //     location: 'The Reading Room, Omaha, Nebraska',
        //     date: 'Thursday, April 2nd, 2026 | 6:00pm',
        //     eventDate: '2026-04-02',
        //     image: './img/events/2026/housebookclubapril.jpg',
        //     link: 'https://www.eventbrite.com/e/the-house-book-club-april-tickets-1979106577048?aff=ebdsoporgprofile',
        //     description: `Join us for our monthly book club discussion! This month we're reading "Chain-Gang All-Stars" by Nana Kwame Adjei-Brenyah. Dive into thought-provoking conversations with fellow readers.`,
        // },
        // {
        //     title: `Old School Game Night`,
        //     location: 'The Union for Contemporary Art, Omaha, Nebraska',
        //     date: 'Saturday, April 18th, 2026 | 2:00pm',
        //     eventDate: '2026-04-18',
        //     image: './img/events/2026/gamenightapril.jpg',
        //     link: 'https://www.eventbrite.com/e/old-school-game-night-april-2026-tickets-1143535729149?aff=ebdsoporgprofile',
        //     description: `Get nostalgic at our Old School Game Night! Break out the classics - Monopoly, Uno, Dominoes, Spades, and more! Bring your favorite vintage games from childhood.`,
        // },
        // {
        //     title: `The House Book Club: May`,
        //     location: 'TBD',
        //     date: 'Thursday, May 7th, 2026 | 6:00pm',
        //     eventDate: '2026-05-07',
        //     image: './img/events/2026/housebookclubmay.jpg',
        //     link: 'https://www.eventbrite.com/e/the-house-book-club-may-tickets-1979106580057?aff=ebdsoporgprofile',
        //     description: `Join us for our monthly book club discussion! This month we're reading "Starseekers" by Nicole Glover. Connect with fellow sci-fi and fantasy enthusiasts.`,
        // },
        // {
        //     title: `Black Fae Day 2026`,
        //     location: 'Miller Park, Omaha, Nebraska',
        //     date: 'Saturday, May 9th, 2026 | 12:00pm',
        //     eventDate: '2026-05-09',
        //     image: './img/events/2026/blackfaeday.jpg',
        //     link: 'https://www.eventbrite.com/e/black-fae-day-2026-tickets-1135020529959?aff=ebdsoporgprofile',
        //     description: `Celebrate Black Fae Day! A magical gathering celebrating Black fantasy, folklore, and fae culture. Join us for a day of wonder, creativity, and community.`,
        // },
        // {
        //     title: `Game Night`,
        //     location: 'The Union for Contemporary Art, Omaha, Nebraska',
        //     date: 'Saturday, May 16th, 2026 | 2:00pm',
        //     eventDate: '2026-05-16',
        //     image: './img/events/2026/gamenightmay.jpg',
        //     link: 'https://www.eventbrite.com/e/game-night-may-2026-tickets-1982107684441?aff=ebdsoporgprofile',
        //     description: `Join us for board games, card games, and friendly competition! All skill levels welcome.`,
        // },
        // {
        //     title: `The House Book Club: June`,
        //     location: 'TBD',
        //     date: 'Thursday, June 4th, 2026 | 6:00pm',
        //     eventDate: '2026-06-04',
        //     image: './img/events/2026/housebookclubjune.jpg',
        //     link: 'https://www.eventbrite.com/e/the-house-book-club-june-tickets-1979107421574?aff=ebdsoporgprofile',
        //     description: `Join us for our monthly book club discussion! This month we're reading "Countess" by Suzan Palumbo. Explore new worlds with fellow book lovers.`,
        // },
        // {
        //     title: `Game Night`,
        //     location: 'The Union for Contemporary Art, Omaha, Nebraska',
        //     date: 'Saturday, June 20th, 2026 | 2:00pm',
        //     eventDate: '2026-06-20',
        //     image: './img/events/2026/gamenightjune.jpg',
        //     link: 'https://www.eventbrite.com/e/game-night-june-2026-tickets-1981532936354?aff=ebdsoporgprofile',
        //     description: `Join us for board games, card games, and friendly competition! All skill levels welcome.`,
        // },
        // {
        //     title: `The House Book Club: September`,
        //     location: 'TBD',
        //     date: 'Friday, September 4th, 2026 | 6:00pm',
        //     eventDate: '2026-09-04',
        //     image: './img/events/2026/housebookclubseptember.jpg',
        //     link: 'https://www.eventbrite.com/e/the-house-book-club-september-tickets-1979107587069?aff=ebdsoporgprofile',
        //     description: `Join us for our monthly book club discussion! This month we're reading "The Bewitching" by Silvia Moreno-Garcia. Dive into gothic horror with fellow readers.`,
        // },
        // {
        //     title: `AfroCon 2026`,
        //     location: 'MCC Center for Advanced and Emerging Technology, Omaha, Nebraska',
        //     date: 'Sunday, October 11th, 2026 | 10:00am',
        //     eventDate: '2026-10-11',
        //     image: './img/events/2026/afrocon2026.jpg',
        //     link: 'https://www.eventbrite.com/e/afrocon-2026-tickets-1979103935146?aff=ebdsoporgprofile',
        //     description: `The premier celebration of Black culture, comics, gaming, and sci-fi/fantasy! Join us for panels, vendors, cosplay, and more at our annual convention.`,
        // },
    ]

    // Filter events into upcoming and past based on current date
    const currentDate = new Date()
    currentDate.setHours(0, 0, 0, 0) // Reset to start of day

    const upcomingEvents = events.filter((event: any) => {
        const eventDate = new Date(event.eventDate)
        eventDate.setHours(23, 59, 59, 999) // Set to end of event day
        return eventDate >= currentDate // Show if event day hasn't passed yet
    })

    const pastEvents = events.filter((event: any) => {
        const eventDate = new Date(event.eventDate)
        eventDate.setHours(23, 59, 59, 999) // Set to end of event day
        return eventDate < currentDate // Past if event day has completely passed
    })

    const renderEventCard = (event: any) => (
        <a
            href={event.link}
            className="card h-100 text-reset text-decoration-none upcoming-event-card"
            target="_blank"
            rel="noopener noreferrer"
        >
            <div className="upcoming-event-card__media">
                <div className="upcoming-event-card__media-frame" aria-hidden="true" />
                <img src={event.image} alt={event.title} />
            </div>
        </a>
    )

    /** Two cards per row in a container; a lone last card uses the same container (width = top two combined). */
    const renderEventCards = (eventsList: any[]) => {
        const rows: React.ReactNode[] = []
        for (let i = 0; i < eventsList.length; i += 2) {
            const chunk = eventsList.slice(i, i + 2)
            const isPair = chunk.length === 2
            rows.push(
                <div className="container" key={`events-row-${i}`}>
                    <div className="row justify-content-center g-3 mb-3">
                        {chunk.map((event: any, j: number) => (
                            <div
                                className={isPair ? 'col-12 col-md-6' : 'col-12'}
                                key={`${event.eventDate}-${event.title}-${j}`}
                            >
                                {renderEventCard(event)}
                            </div>
                        ))}
                    </div>
                </div>
            )
        }
        return <>{rows}</>
    }

    return (
        <>
            {/* Upcoming Events Section */}
            <section
                className="page-section"
                id="upcoming"
                style={
                    {
                        ['--upcoming-bg-image' as string]: `url("${SIGNATURE_BG}")`,
                    } as React.CSSProperties
                }
            >
                <div className="container">
                    <div className="text-center">
                        <h2 className="section-heading text-uppercase">Signature Events</h2>
                    </div>
                </div>
                <div className="container">
                    <div className="row g-3 mb-4 align-items-stretch">
                        <div className="col-12 col-md-6">
                            <div className="upcoming-feature-media">
                                <a href="/signature-events" aria-label="Go to Signature Events page">
                                    <img src="./img/events/faeday2026.png" alt="Black Fae Day 2026" className="img-fluid w-100" />
                                </a>
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="upcoming-feature-media">
                                <iframe
                                    className="upcoming-feature-media__iframe"
                                    width="100%"
                                    src="https://www.youtube.com/embed/VwLUcn4RK4I"
                                    title="Black Fae Day YouTube Short"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
                {upcomingEvents.length > 0 ? (
                    renderEventCards(upcomingEvents)
                ) : (
                    <div className="container text-center">
                        <h3>Check back soon for more events!</h3>
                    </div>
                )}
            </section>

            {/* Past Events Section - Only show if there are past events */}
            {pastEvents.length > 0 && (
                <section className="page-section bg-light" id="past-events">
                    <div className="container">
                        <div className="text-center">
                            <h2 className="section-heading text-uppercase">Past Events</h2>
                        </div>
                    </div>
                    {renderEventCards(pastEvents)}
                </section>
            )}
        </>
    )
}

export default Upcoming
